$(document).ready(function () {
  $(".banner-section .banner-list").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

    $(".banner-section-mobile .banner-list-mobile").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

   $(".summer-sale-inner").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

  
  
  $(".design-carousel-section .slider-blocks").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $("#testimonials-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  

  $(".customer-slider .customer-list").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(".summer-customer-slider .customer-list").slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(".products-slider .product-list").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0'
        }
      }
    ]
  });

  $(".products-slider-new .product-list").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '110px'
  });


$(".find_your_parfect_sc .product-lists").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px'
        }
      }
    ]
  });




});



// Sticky mobile footer menu - open header mobile menu on Menu button click
$(document).on('click', '.shopify-mobile-navbar a[href="/pages/menu"]', function (e) {
  if (window.innerWidth > 798) {
    return;
  }

  e.preventDefault();

  if (window.mobileMenuDrawer) {
    window.mobileMenuDrawer.open();
    return;
  }

  var menuTrigger = document.querySelector('[data-mobile-menu-trigger]');
  if (menuTrigger) {
    menuTrigger.click();
  }
});

// Mobile product gallery: show dots instead of thumbnails
var MOBILE_GALLERY_MAX_WIDTH = 798;

function isMobileProductGalleryView() {
  return window.innerWidth <= MOBILE_GALLERY_MAX_WIDTH;
}

function setupMobileProductGalleryDots() {
  if (!isMobileProductGalleryView()) {
    return;
  }

  $('.product-main [data-product-gallery]').each(function () {
    var $gallery = $(this);

    if ($gallery.data('mobile-dots-enabled')) {
      return;
    }

    var flkty = $gallery.data('flickity');
    if (!flkty) {
      return;
    }

    var $wrap = $gallery.closest('.gallery-wrap');
    var $thumbNav = $wrap.find('[data-product-gallery-thumbnails]');
    var mediaCount = parseInt($gallery.data('media-count'), 10) || $gallery.find('.gallery-cell').length;

    if (mediaCount <= 1) {
      $thumbNav.hide();
      $gallery.data('mobile-dots-enabled', true);
      return;
    }

    if ($thumbNav.data('flickity')) {
      $thumbNav.flickity('destroy');
    }

    $thumbNav.hide();

    var selectedIndex = flkty.selectedIndex || 0;
    var slideshowSpeed = parseInt($gallery.data('slideshow-speed'), 10) || 0;

    $gallery.flickity('destroy');
    $gallery.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      dragThreshold: 10,
      imagesLoaded: true,
      pageDots: true,
      prevNextButtons: true,
      autoPlay: slideshowSpeed > 0 ? slideshowSpeed * 1000 : false,
      watchCSS: false,
      initialIndex: selectedIndex
    });

    $gallery.addClass('mobile-gallery-dots-enabled');
    $gallery.data('mobile-dots-enabled', true);
  });
}

function waitForProductGalleryDots() {
  if (!isMobileProductGalleryView()) {
    return;
  }

  var $galleries = $('.product-main [data-product-gallery]');
  if (!$galleries.length) {
    return;
  }

  var hasReadyGallery = $galleries.toArray().some(function (gallery) {
    return $(gallery).data('flickity');
  });

  if (hasReadyGallery) {
    setupMobileProductGalleryDots();
    return;
  }

  setTimeout(waitForProductGalleryDots, 100);
}

$(document).ready(function () {
  waitForProductGalleryDots();
});

$(window).on('load', waitForProductGalleryDots);

$(document).on('ready.flickity', '.product-main [data-product-gallery]', function () {
  setupMobileProductGalleryDots();
});


// popup

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');
  
      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });
  
  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });
  
  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }
});